import { render, staticRenderFns } from "./PropertyInterventions.vue?vue&type=template&id=17265d20"
import script from "./PropertyInterventions.vue?vue&type=script&lang=js"
export * from "./PropertyInterventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports